import React from 'react';
import { useMount } from 'ahooks';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Provider } from 'mobx-react';
import { AppStore } from './store';
import { baseRoutes } from './routers';
import { getBaseUrl } from './utils';
import { sensorsInit } from './utils/sensors-data';
import loadResource from './utils/loader';
import * as Sentry from '@sentry/react';
import { environment } from '@gaodun.com/gtools';
import './app.less';

const store = new AppStore();

sensorsInit();

const Loading = (
    <div className="loading-container">
        <Spin fullscreen indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} size="large" />
    </div>
);

const initSentry = () => {
    Sentry.init({
        dsn: 'https://c31b875799fe12ea865f738ee0cb26b3@sentry.gaodun.com/113',
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 1.0, // 触发异常后发送给 Sentry 的概率
        maxBreadcrumbs: 50, // 控制应捕获的面包屑(行为栈)的总量
        profilesSampleRate: 0.01, // 性能分析的采样率
        replaysSessionSampleRate: 0, // 重播的采样率
        replaysOnErrorSampleRate: 0.01, // 发生错误时录制的重放的采样率，最多从错误放生时前1分钟开始记录
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
            'ResizeObserver loop',
            'h is not defined',
            "Can't find variable: h",
            'Malformed UTF-8 data',
            'Network Error',
        ],
    });
};

function App() {
    useMount(() => {
        loadResource('https://gd-file.gaodun.com/browser-modal/bundle.js', 'js', () => {
            window.useCompatibilityModal();
        });
        if (environment.getApiEnv() === '' || localStorage.getItem('sentry')) {
            initSentry();
        }
    });

    return (
        <Provider store={store}>
            <BrowserRouter basename={getBaseUrl()}>
                <Routes>
                    {baseRoutes.map(item => (
                        <Route
                            key={item.path}
                            path={item.path}
                            element={
                                <React.Suspense fallback={Loading}>
                                    <item.element key={item.path} />
                                </React.Suspense>
                            }
                        />
                    ))}
                </Routes>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
